import { Struct } from "@solana/web3.js";
import { PROGRAM_SCHEMA } from "../schema";
import { HapiInstruction } from "../state";
export class CreateCommunityIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.CreateCommunity;
    }
}
PROGRAM_SCHEMA.set(CreateCommunityIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["name", "string"],
    ],
});
export class UpdateCommunityIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.UpdateCommunity;
    }
}
PROGRAM_SCHEMA.set(UpdateCommunityIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["name", "string"],
    ],
});
export class CreateNetworkIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.CreateNetwork;
    }
}
PROGRAM_SCHEMA.set(CreateNetworkIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["name", "string"],
    ],
});
export class CreateReporterIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.CreateReporter;
    }
}
PROGRAM_SCHEMA.set(CreateReporterIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["reporterType", "u8"],
        ["name", "string"],
    ],
});
export class UpdateReporterIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.UpdateReporter;
    }
}
PROGRAM_SCHEMA.set(UpdateReporterIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["reporterType", "u8"],
        ["name", "string"],
    ],
});
export class CreateCaseIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.CreateCase;
    }
}
PROGRAM_SCHEMA.set(CreateCaseIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["caseId", "u64"],
        ["categories", "u32"],
        ["status", "u8"],
        ["name", "string"],
    ],
});
export class UpdateCaseIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.UpdateCase;
    }
}
PROGRAM_SCHEMA.set(UpdateCaseIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["categories", "u32"],
        ["status", "u8"],
    ],
});
export class CreateAddressIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.CreateAddress;
    }
}
PROGRAM_SCHEMA.set(CreateAddressIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["address", [32]],
        ["risk", "u8"],
        ["caseId", "u64"],
        ["category", "u8"],
    ],
});
export class UpdateAddressIx extends Struct {
    constructor() {
        super(...arguments);
        this.tag = HapiInstruction.UpdateAddress;
    }
}
PROGRAM_SCHEMA.set(UpdateAddressIx, {
    kind: "struct",
    fields: [
        ["tag", "u8"],
        ["risk", "u8"],
        ["caseId", "u64"],
        ["category", "u8"],
    ],
});
//# sourceMappingURL=instructions.js.map